import _styled from '@emotion/styled/base';
import { getLinkStyles } from './styled.js';
/** @component */

var Link = _styled("a", process.env.NODE_ENV === "production" ? {
  target: "e1ewv86t0"
} : {
  target: "e1ewv86t0",
  label: "Link"
})(getLinkStyles, ";");

export { Link };
